module.exports = __webpack_public_path__ + "5fa5ddf25fd9923e48c22b398a1c315a.svg";